import { Injectable } from "@angular/core";
import * as Big from "big.js";
import { INVOICE_STATUS } from "e2e/helpers/investment.helper";
import moment from "moment";
import { Observable } from "rxjs";
import { getDaysDiff, getTodayDateOnly } from "src/app/shared/util/date.util";
import { environment } from "src/environments/environment";
import { xml2json } from "xml-js";
import { RESTService } from "../../../shared/services/rest.service";
import { formatFilter } from "../../../shared/util/api.util";
@Injectable({
  providedIn: "root",
})
export class EmailService {
  constructor(private rest: RESTService) {}

  getAllCompanies(): Observable<any> {
    return this.rest.get(`/inicio-operacion-emails`);
  }

  getOperationsToBeLinked(emailId, replyId): Observable<any> {
    return this.rest.get(
      `/response-email/operation?emailId=${emailId}&replyId=${replyId}`
    );
  }

  getOperationsByDebtor(debtorId: string, emailId: string, replyId: string): Observable<any> {
    return this.rest.get(
      `/response-email/debtor?debtorId=${debtorId}&emailId=${emailId}&replyId=${replyId}`
    );
  }

  hideEmail(id: string): Observable<any> {
    return this.rest.patch(`/inicio-operacion-emails/${id}`, {
      status: "hidden",
    });
  }

  getEmailReplies(id: string): Observable<any> {
    return this.rest.get(`/inicio-operacion-email/${id}`);
  }

  linkOperationsToEmail(payload: {
    emailId: any;
    emailReplyId: any;
    operationIds: any;
  }) {
    return this.rest.patch(`/inicio-operacion-emails`, payload);
  }
}
